import { isVersionGreater, normalizeVersionStr } from "src/app/utils";

export const getLatestVersion = (versionArray) => {
  let latestIndex = -1;
  const normalized = versionArray.map((v) => normalizeVersionStr(v.versionNum));
  for (let i = 0; i < normalized.length; i++) {

    if (latestIndex === -1 || isVersionGreater(normalized[i], normalized[latestIndex])) {
      latestIndex = i;
    }
  }
  return versionArray[latestIndex];
};